import { TableContainer, Table, TableHead, TableCell, TableRow, TableBody, Paper } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import useConfigStyles from '../../components/useConfigStyles';
import React from 'react';
import { Variable } from '../../types/variable';

type JobVariablesProps = {
  variables: Variable[];
  editable: boolean;
  removeVariable: (variable: Variable) => void;
};

function JobVariables({ variables, editable, removeVariable }: JobVariablesProps): JSX.Element {
  const classes = useConfigStyles();
  const handleOnDelete = (variable: Variable) => {
    removeVariable(variable);
  };

  const allowDelete = (variable: Variable) => {
    if (variable.Name === 'SchoolYear' || variable.Name === 'District') {
      return false;
    }
    return true;
  };

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className='table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Variable</TableCell>
            <TableCell align='right'>Value</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {variables.map((variable) => (
            <TableRow key={variable.Name}>
              <TableCell component='th' scope='row'>
                {variable.Name}
              </TableCell>
              <TableCell align='right'>{variable.Value}</TableCell>
              <TableCell align='right'>
                {editable && allowDelete(variable) && (
                  <IconButton color='secondary' onClick={() => handleOnDelete(variable)}>
                    <DeleteIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default JobVariables;
